import { ChangeEvent, ReactElement, useCallback } from 'react'
import { ReactComponent as Arrow } from './assets/arrow.svg'
import InputSelectProps from './props'
import * as S from './styled'

export default function InputSelect ({ children, disabled, id, label, name, onChange, required, ...rest }: InputSelectProps): ReactElement {
  const handleChange = useCallback((evt: ChangeEvent<HTMLSelectElement>) => {
    if (onChange != null) onChange(evt.target.value)
  }, [onChange])

  return <S.Container>
    <S.Label htmlFor={name}>{label}</S.Label>

    <S.FormSelect>
      <S.Select
        disabled={disabled}
        id={id}
        name={name}
        onChange={handleChange}
        required={required}
        {...rest}
      >
        {children}
      </S.Select>

      <S.ArrowContainer>
        <Arrow />
      </S.ArrowContainer>
    </S.FormSelect>
  </S.Container>
}
